import { handleStreamResponse } from '../chats';

const API_URL = process.env.REACT_APP_API_URL;
const AGENT_CHATS_URL = `${API_URL}/api/agent-chats`;

// Send message to agent
export const sendAgentMessage = async (
    chatId, agentId, { content, parentId, guestChatToken = null }, onUpdate,
) => {
    try {
        const actualChatId = chatId || 'new';
        const url = new URL(`${AGENT_CHATS_URL}/${actualChatId}`);
        if (guestChatToken) {
            url.searchParams.append('guest_token', guestChatToken);
        }

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify({
                content,
                parentId,
                agentId,
            }),
        });

        if (!response.ok) {
            const error = await response.json() || { error: 'Failed to regenerate message' };
            throw error;
        }

        await handleStreamResponse(response, onUpdate);
    } catch (error) {
        console.error('Error sending agent message:', error);
        throw error;
    }
};

export const fetchAgentChatHistory = async chatId => {
    try {
        const response = await fetch(`${AGENT_CHATS_URL}/${chatId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        });

        if (response.status === 404) {
            throw new Error('chat_not_found');
        }
        if (response.status === 401) {
            throw new Error('unauthorized');
        }
        if (response.status === 403) {
            throw new Error('forbidden');
        }

        if (!response.ok) {
            throw new Error('Failed to fetch chat history');
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching chat history:', error);
        throw error;
    }
};

export const fetchAgentChatHistoryByToken = async guestToken => {
    try {
        const url = new URL(`${AGENT_CHATS_URL}/by-token`);
        if (guestToken) {
            url.searchParams.append('guest_token', guestToken);
        }

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        });

        if (response.status === 404) {
            throw new Error('chat_not_found');
        }

        if (!response.ok) {
            throw new Error('Failed to fetch chat history');
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching chat history by token:', error);
        throw error;
    }
};

export const fetchAgentTools = async (messageId, guestChatToken = null) => {
    try {
        const url = new URL(`${AGENT_CHATS_URL}/messages/${messageId}/tools`);
        if (guestChatToken) {
            url.searchParams.append('guest_token', guestChatToken);
        }

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        });

        if (!response.ok) {
            throw new Error('Failed to fetch agent tools by message id');
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching agent tools by message id:', error);
        throw error;
    }
};
